import React from 'react';
import { Box, Button, Tooltip, Typography } from '@mui/material';
import useNavColors from './navColors';
import NavIcon from './NavIcon';
import config from '@/config';

interface DrawerFeedbackProps {
    isOpen: boolean;
}

const DrawerFeedback: React.FC<DrawerFeedbackProps> = ({ isOpen }) => {
    const navColors = useNavColors();

    if (!isOpen) {
        return (
            <Tooltip title={'feedback'} placement="right">
                <Button
                    component="a"
                    href={config?.feedbackUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        justifyContent: 'center',
                        minWidth: 0,
                        ml: 0.1,
                        p: 0,
                        mb: 1,
                        cursor: 'pointer',
                    }}
                >
                    <NavIcon icon={'Campaign'} isActive={true} />
                </Button>
            </Tooltip>
        );
    }

    return (
        <Box
            sx={{
                mx: 1,
                mb: 1,
                p: 1,
                borderRadius: 1.75,
                background: '#4f53af73',
                boxShadow: 'inset 0 1px 0 rgba(255, 255, 255, 0.08)',
                whiteSpace: 'normal',
                overflow: 'hidden',
                opacity: 0,
                transition: 'opacity 0.3s ease-in',
                animation: 'fade-in 0.3s forwards',
                '@keyframes fade-in': {
                    to: { opacity: 1 },
                },
            }}
        >
            <Typography variant="h5" sx={{ color: navColors.text, fontWeight: 700, mb: 1, fontSize: '0.8rem' }}>
                Enjoy AI Insights?
            </Typography>
            <Typography
                variant="body2"
                sx={{
                    color: 'rgba(255, 255, 255, 0.92)',
                    fontSize: '0.75rem',
                    lineHeight: 1.45,
                    mb: 1.5,
                    whiteSpace: 'normal',
                    overflowWrap: 'anywhere',
                }}
            >
                We&apos;d like to know how your experience is to make our product better.
            </Typography>
            <Button
                component="a"
                href={config?.feedbackUrl}
                target="_blank"
                rel="noopener noreferrer"
                variant="outlined"
                sx={{
                    width: '100%',
                    p: 0,
                    minHeight: 32,
                    borderWidth: 1.5,
                    borderColor: 'rgba(255, 255, 255, 0.85)',
                    borderRadius: 1.7,
                    color: navColors.text,
                    fontSize: '0.82rem',
                    fontWeight: 700,
                    textTransform: 'none',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                        borderWidth: 1.5,
                        borderColor: navColors.text,
                        backgroundColor: 'rgba(255, 255, 255, 0.08)',
                    },
                }}
            >
                Send feedback
            </Button>
        </Box>
    );
};

export default DrawerFeedback;
